module.exports = __webpack_public_path__ + "static/media/persona-customizing.a5bedbeb.png";